<template>
    <div id="page_Container" :class="{'no-product': noProduct}">
        <div class="page" id="group-detail" v-if="!noProduct">
            <div id="main-container">
                <van-panel>
                    <div slot="header" class="van-cell van-panel__header">
                        <van-tag color="#EE2E50">{{groupData.groupName}}</van-tag>
                    </div>
                    <Goods style="padding: 9px 12px" :goodsData="gooditem" v-for="gooditem in groupData.productGroupItemList" :key="gooditem.id"></Goods>
                </van-panel>
                <!-- <van-cell>
                    <template slot="title">
                        <van-tag color="#EE2E50">优惠套装</van-tag>
                    </template>
                </van-cell> -->
            </div>
            <div class="group-detail-footer">
                <op-submit-bar :num="groupData.productGroupItemList && groupData.productGroupItemList.length" @submit="onSubmit(groupData)" :price="groupData.groupSellPrice"></op-submit-bar>
            </div>

        </div>
        <div v-else class="no-product" >
            <img  src="../assets/img/myCenter/noProduct.png" alt="">
            <div>套装商品已下架</div>
        </div>
    </div>
</template>

<script>
import Goods from '@/components/common/goods';
import OPSubmitBar from '@/components/common/opSubmitBar';
import {
    mapActions
} from 'vuex';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
export default {
    components: {
        Goods,
        'op-submit-bar': OPSubmitBar
    },
    data() {
        return {
            groupData: {}
        };
    },
    esvShow() {
        this.queryProductGroup();
        this.setAddressBeginId('-1'); // 清空地址id
    },
    methods: {
        ...mapActions(['setAddressBeginId']),
        onSubmit(group) {
            const orderJsonList = [];
            group.productGroupItemList.forEach(item => {
                // TODO spreadingCode 套装商品支持分销
                const { productId, skuCode, quantity } = item;
                orderJsonList.push({
                    productId, skuCode, quantity, spreadingCode: this.spreadingCode
                });
            });

            const params = { orderJsonList: JSON.stringify(orderJsonList), participate: 1, productGroupId: group.id, usePointFlag: 1 };
            this.$doRequest(
                {
                    url: '/order/settlement',
                    params: params,
                    before: function() {
                        this.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    const result = data.result;
                    result.orderRespDTOList.forEach((item, index) => {
                        console.log(item.value.activeList);

                        const activeList = item.value.activeList && JSON.parse(item.value.activeList);
                        if (activeList && activeList.length > 0) {
                            activeList.push({ activityId: -1,
                                activityTitle: '不使用活动',
                                activityType: 4
                            });
                        }
                        item.value.activeList = JSON.stringify(activeList);
                    });
                    // TODO 要整整
                    this.ESVStorage.putSavedValue('requireInfo', result);
                    this.ESVStorage.putSavedValue('requireInfoall', result);
                    const arr = [];
                    this.ESVStorage.putSavedValue('invoiceArr', arr);
                    this.ESVStorage.putSavedValue('submitType', '2');
                    this.esvOpenPage({ name: 'OPConfirmOrder', params: { productGroupId: group.id } });
                }
            );
        },
        queryProductGroup(params) {
            params = params || { id: this.$route.query.id };
            this.$doRequest({
                url: '/groupsell/queryProductGroup',
                params,
                before: () => {
                    this.loading = toastLoading();
                },
                complete: () => {
                    // this.loading = false;
                    clearToastLoading(this.loading);
                }
            }, (data) => {
                this.groupData = data.result;
            });
        }
    },
    computed: {
        noProduct() {
            return Number(this.groupData.status) !== 1;
        }
    }
};
</script>

<style lang="scss">
    #group-detail {
        .op-submit-bar {

        }
        .group-detail-footer {
            padding: 0 10px;
            background: #fff;
            width: 100%;
            bottom: 0;
            position: fixed;
        }
    }
    .no-product {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        img {
            width: 80%;
            display: block;
            margin-bottom: 20px;
        }
        color: #999;
        text-align: center;
    }

</style>
